<button style="display: flex; align-items: center; gap: 10px;" type="button" class="profile-link" (click)="toggleProfile($event)" [attr.aria-expanded]="profileIsExpanded" aria-controls="profile-container">
	profile
	<svg width="28" height="28" viewBox="0 0 24 24" fill="grey" xmlns="http://www.w3.org/2000/svg"><path d="M6 9L12 15L18 9"/></svg>
</button>

<div class="profile-container" id="profile-container" [class.profile-container--open]="profileIsExpanded">
	<div style="padding: 0px 15px 12px 15px; border-bottom:1px solid var(--color-secnav-border); font-weight:500;">
		{{ emailAddress }}
	</div>
	<div style="padding: 12px 15px 12px 15px; border-bottom:1px solid var(--color-secnav-border);">
		<span (click)="openProfile()" style="cursor: pointer;">profile and password</span>
	</div>
	<div style="padding: 12px 15px 0px 15px;">
		<a [routerLink]="['/signout']" href="">sign out</a>
	</div>
</div>
